import { render, staticRenderFns } from "./Youhuiquan.vue?vue&type=template&id=9e1c886a&scoped=true&"
import script from "./Youhuiquan.vue?vue&type=script&lang=js&"
export * from "./Youhuiquan.vue?vue&type=script&lang=js&"
import style0 from "./Youhuiquan.vue?vue&type=style&index=0&id=9e1c886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1c886a",
  null
  
)

component.options.__file = "Youhuiquan.vue"
export default component.exports